export default function StatCard({ icon, title, value, color }) {
  return (
    <div className="bg-gray-50 p-6 rounded-xl shadow flex items-center space-x-4">
      <div className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-300 bg-opacity-30">
        {icon}
      </div>
      <div>
        <p className="text-sm text-[#931b1c] opacity-80">{title}</p>
        <p className="text-2xl font-bold text-[#931b1c]">{value}</p>
      </div>
    </div>
  );
}
